import { Button, Card, Form, Input, message, notification, Radio } from "antd";
import React, { useState } from "react";
import Utils from "../utils/Utils";
import { interviewDemoGetUrl, reportDemoGetUrl } from "../../api";
import Loader from "../Loader";
import { CopyOutlined } from "@ant-design/icons";

function ReportUrls() {
  const [selectedUrl, setSelectedUrl] = useState("interviewUrl");
  const [urlData, setUrlData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleRadioChange = (e) => {
    // console.log("Selected Value:", e.target.value);
    setSelectedUrl(e.target.value);
  };
  const handleCopy = () => {
    navigator.clipboard
      .writeText(
        urlData?.interviewUrl ? urlData?.interviewUrl : urlData?.reportUrl
      )
      .then(() => {
        setCopied(true);
        message.success("Link copied to clipboard!");

        // Reset copied state after 3 seconds
        setTimeout(() => {
          setCopied(false);
        }, 3000); // 3000ms = 3 seconds
      })
      .catch(() => {
        message.error("Failed to copy link.");
      });
  };
  const onFinish = async (values) => {
    // console.log("Form Values:", values);
    let url = "";
    if (selectedUrl === "interviewUrl") {
      url = interviewDemoGetUrl;
    } else {
      url = reportDemoGetUrl;
    }
    setLoading(true);
    try {
      const response = await fetch(
        url +
          "?passcode=" +
          values.adminPassword +
          "&interviewId=" +
          values.interviewId,
        {
          method: "GET", // Specify the request method
          headers: {
            "Content-Type": "application/json", // Tell the server you're sending JSON
          },
          //   body: JSON.stringify(reqBody), // Convert your data object to a JSON string
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json(); // Parse the JSON response
      //   console.log(result); // Handle the response from the server
      if (result.resultStatusInfo.resultCode === "SUCCESS") {
        setUrlData(result.data);
      } else {
        notification.error({
          description: `Unauthorize / Not found`,
          // icon: <Icon type="green-tick" />,
          placement: "topRight",
          showProgress: true,
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error occurred while sending the request:", error);
    }
  };
  return (
    <>
      {loading && <Loader />}
      <Card
        //   title="Interview Schedule Form"
        className="sm:w-[600px] w-full"
        style={{ margin: "20px auto" }}
      >
        {urlData ? (
          <div>
            <div className="flex sm:flex-row flex-col gap-3">
              <div className="w-full">
                <p className="w-full text-lg font-semibold">Interview ID</p>
                <p className="w-full font-semibold">{urlData.interviewId}</p>
              </div>
              <div className="w-full">
                <p className="w-full text-lg font-semibold">Interview Type</p>
                <p className="w-full  font-semibold">{urlData.interviewType}</p>
              </div>
            </div>
            <div className="flex sm:flex-row flex-col gap-3 mt-2">
              <div className="w-full">
                <p className="w-full text-lg font-semibold">Job Title</p>
                <p className="w-full font-semibold">{urlData.jobTitle}</p>
              </div>
              <div className="w-full ">
                <p className="w-full text-lg font-semibold">companyName Name</p>
                <p className="w-full  font-semibold">{urlData.companyName}</p>
              </div>
            </div>
            <div className="flex sm:flex-row flex-col gap-3 mt-2">
              <div className="w-full ">
                <p className="w-full text-lg font-semibold">Candidate Name</p>
                <p className="w-full  font-semibold">{urlData.candidateName}</p>
              </div>
              <div className="w-full">
                <p className="w-full text-lg font-semibold">Email ID</p>
                <p className="w-full  font-semibold">{urlData.emailId}</p>
              </div>
            </div>
            <div className="flex sm:flex-row flex-col gap-3 mt-2">
              <div className="w-full ">
                <p className="w-full text-lg font-semibold">
                  Interview Duration
                </p>
                <p className="w-full font-semibold">
                  {Utils.convertSecondsToTime(urlData?.interviewDuration)}
                </p>
              </div>
              <div className="w-full">
                <p className="w-full text-lg font-semibold">
                  Interview validity
                </p>
                <p className="w-full  font-semibold">
                  {Utils.converToDateMonthYear(urlData?.interviewValidityDate)}
                </p>
              </div>
            </div>
            <div className="break-all mt-3">
              <div
                style={{ userSelect: "text" }}
                className="bg-gray-200 p-2 rounded-lg"
              >
                {urlData?.interviewUrl
                  ? urlData?.interviewUrl
                  : urlData?.reportUrl}
                {"  "}
              </div>
              <div className="flex justify-end mt-1">
                {copied ? (
                  <span className="text-green-500">Copied!</span>
                ) : (
                  <CopyOutlined
                    onClick={handleCopy}
                    className="cursor-pointer text-blue-500"
                    title="Click to copy"
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div>
              <Form
                layout="vertical"
                onFinish={onFinish}
                initialValues={{
                  interviewId: "",
                  adminPassword: "",
                }}
              >
                <div className="flex sm:flex-row flex-col gap-3 w-full mt-5">
                  <Form.Item
                    label="Interview ID"
                    name="interviewId"
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the Interview ID",
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Enter Interview ID" />
                  </Form.Item>

                  <Form.Item
                    label="Admin Password"
                    name="adminPassword"
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the Admin Password",
                      },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      placeholder="Enter Admin Password"
                    />
                  </Form.Item>
                </div>
                <div className="flex justify-center gap-4">
                  <Radio.Group
                    defaultValue="interviewUrl"
                    onChange={handleRadioChange}
                  >
                    <Radio
                      className="font-semibold text-lg "
                      value="interviewUrl"
                    >
                      Interview Url
                    </Radio>
                    <Radio className="font-semibold text-lg" value="reportUrls">
                      Report Url
                    </Radio>
                  </Radio.Group>
                </div>

                <Form.Item className="mt-4">
                  <Button size="large" type="primary" htmlType="submit" block>
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </>
        )}
      </Card>
    </>
  );
}

export default ReportUrls;
